import FilterSelect from '@/components/filters/FilterSelect';
import SummaryCard from '@/components/cards/SummaryCard';
import OverviewChart from '@/components/charts/LineChart';
import { SummaryData, TimeRange } from '../constants/types';

interface Props {
  summaryData: SummaryData[];
  chartData: any[];
  timeRange: TimeRange;
  setTimeRange: (v: TimeRange) => void;
  timeRangeOptions: any[];
}

const CampaignsSection: React.FC<Props> = ({
  summaryData,
  chartData,
  timeRange,
  setTimeRange,
  timeRangeOptions,
}) => (
  <div className="bg-white p-10 rounded-[24px] space-y-8">
    <div className="flex items-center justify-between">
      <h2 className="text-[32px] font-[700]">Campaigns</h2>
      <div className="flex gap-4">
        <FilterSelect value={timeRange} onChange={(e) => setTimeRange(e.target.value)} options={timeRangeOptions} />
      </div>
    </div>
    <div className="grid grid-cols-5 gap-4">
      {summaryData.map((item) => (
        <SummaryCard key={item.label} {...item} />
      ))}
    </div>
    <OverviewChart chartData={chartData} />
  </div>
);

export default CampaignsSection;
